<template>
    <transition name="fade-slide-left" mode="out-in" appear >
        <div class="response--bar position--fixed display--flex background--white shadow--default">
            <icon-success v-if="settings.status === 'success'" class="response--bar__svg" />
            <icon-error v-else class="response--bar__svg"  />
            <span class="response--bar__text">
                {{ settings.message }}
            </span>
        </div>
    </transition>
</template>

<script>
export default {
    components: {
        IconSuccess: () => import( /* webpackChunkName: 'IconSuccess' */ '@/components/bundles/layout/images/icons/IconSuccess' ),
        IconError: () => import( /* webpackChunkName: 'IconError' */ '@/components/bundles/layout/images/icons/IconError' )
    },
    props: {
        settings: Object
    }
};
</script>

<style lang="scss">
    // =============================================================================
    // Animations
    // =============================================================================
    @include keyframes ( fadeIn ) {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }

    // =============================================================================
    // Style
    // =============================================================================
    .response {
        &--bar {
            @include transform-position( false, false, 50px, 131px );
            align-items: center;
            min-width: 520px;
            min-height: 73px;
            padding: 22px 30px;
            @include rounded-corner( 5px );
            z-index: 999;
            &__svg {
                margin-right: 15px;
            }
            &__text {
                @include animation( fadeIn .6s ease-in-out );
            }
        }
    }
</style>